/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserAccountsResponseItem } from './search-user-accounts-response-item';


export interface SearchUserAccountsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserAccountsResponseItem> | null;
}

